export default{
    methods:{
        trackPage: function (path) {
            this.$gtag.pageview({
                page_path: path,
            })
        },
        fbTrack:function(event,obj={}){
            // eslint-disable-next-line
            fbq('track',event,obj)
        }
    }
}